import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Title from "./Title";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import DirectionsIcon from "@material-ui/icons/Directions";
import {addAdmin} from "../services/firebase";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    loader: {
        margin: theme.spacing(1),
    },
    root: {
        padding: "2px 4px",
        marginTop: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        width: "100%",
        backgroundColor: "#f5f5f5",
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
}));

export default function AddAdmin() {
    const classes = useStyles();
    const [value, setValue] = useState("");
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        if(!window.confirm(`Are you sure you would like to add ${value} as an admin?`)) {
            return;
        }
        addAdmin(value);
        setValue("");
    }

    return (
        <React.Fragment>
            <Title>Invite a New Admin</Title>
            <Typography color="textSecondary" className={classes.score}>
                Admins can grade submissions and add other admins.
            </Typography>
            <Paper
                component="form"
                className={classes.root}
                onSubmit={(event) => handleSubmit(event)}
            >
                <InputBase
                    className={classes.input}
                    placeholder="Enter email"
                    inputProps={{ "aria-label": "flag" }}
                    onChange={handleChange}
                    value={value}
                />
                <IconButton
                    color="primary"
                    type="submit"
                    className={classes.iconButton}
                    aria-label="directions"
                >
                    <DirectionsIcon />
                </IconButton>
            </Paper>
        </React.Fragment>
    );
}
